<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>VAHAN 02 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Vehicle No (MA6MFBC1BBT096358)</label>
          <model-list-select
            :list="$store.getters['commonDropdownMaster/getAllVehicleDDList']"
            v-model="vehiclenumber"
            option-value="chassisNo"
            option-text="label"
            placeholder="Select Vehicle No"
          ></model-list-select>
        </b-col>
        <b-col md="3">
          <b-button
            v-if="vehiclenumber"
            @click="getAllVAHAN02Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <div v-if="!getAllVAHAN02 || getAllVAHAN02.stautsMessage !== 'OK'">
        <b class="text-danger">{{ "No data found." }}</b>
      </div>
      <div v-else>
        <b-row>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registration Number:</strong>
            {{ getAllVAHAN02.rc_regn_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registration Date:</strong>
            {{ getAllVAHAN02.rc_regn_dt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registration Upto:</strong>
            {{ getAllVAHAN02.rc_regn_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Owner Name:</strong>
            {{ getAllVAHAN02.rc_owner_name }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Father's Name:</strong>
            {{ getAllVAHAN02.rc_f_name }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Present Address:</strong>
            {{ getAllVAHAN02.rc_present_address }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permanent Address:</strong>
            {{ getAllVAHAN02.rc_permanent_address }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Mobile Number:</strong>
            {{ getAllVAHAN02.rc_mobile_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Vehicle Category:</strong>
            {{ getAllVAHAN02.rc_vch_catg }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Vehicle Class Description:</strong>
            {{ getAllVAHAN02.rc_vh_class_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Chassis Number:</strong>
            {{ getAllVAHAN02.rc_chasi_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Engine Number:</strong>
            {{ getAllVAHAN02.rc_eng_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Maker Description:</strong>
            {{ getAllVAHAN02.rc_maker_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Model:</strong>
            {{ getAllVAHAN02.rc_maker_model }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Fuel Type:</strong>
            {{ getAllVAHAN02.rc_fuel_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Color:</strong>
            {{ getAllVAHAN02.rc_color }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Fitness Upto:</strong>
            {{ getAllVAHAN02.rc_fit_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>National Permit Upto:</strong>
            {{ getAllVAHAN02.rc_np_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Insurance Company:</strong>
            {{ getAllVAHAN02.rc_insurance_comp }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Insurance Policy Number:</strong>
            {{ getAllVAHAN02.rc_insurance_policy_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Insurance Upto:</strong>
            {{ getAllVAHAN02.rc_insurance_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Manufacturer Month/Year:</strong>
            {{ getAllVAHAN02.rc_manu_month_yr }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Unloaded Weight:</strong>
            {{ getAllVAHAN02.rc_unld_wt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Gross Vehicle Weight:</strong>
            {{ getAllVAHAN02.rc_gvw }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Number of Cylinders:</strong>
            {{ getAllVAHAN02.rc_no_cyl }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Cubic Capacity:</strong>
            {{ getAllVAHAN02.rc_cubic_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Seating Capacity:</strong>
            {{ getAllVAHAN02.rc_seat_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Sleeper Capacity:</strong>
            {{ getAllVAHAN02.rc_sleeper_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Wheelbase:</strong>
            {{ getAllVAHAN02.rc_wheelbase }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registered At:</strong>
            {{ getAllVAHAN02.rc_registered_at }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Status As On:</strong>
            {{ getAllVAHAN02.rc_status_as_on }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>PUCC Upto:</strong>
            {{ getAllVAHAN02.rc_pucc_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>PUCC Number:</strong>
            {{ getAllVAHAN02.rc_pucc_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Status:</strong>
            {{ getAllVAHAN02.rc_status }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Number:</strong>
            {{ getAllVAHAN02.rc_permit_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Issue Date:</strong>
            {{ getAllVAHAN02.rc_permit_issue_dt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Valid From:</strong>
            {{ getAllVAHAN02.rc_permit_valid_from }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Valid Upto:</strong>
            {{ getAllVAHAN02.rc_permit_valid_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Type:</strong>
            {{ getAllVAHAN02.rc_permit_type }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Code:</strong>
            {{ getAllVAHAN02.rc_permit_code }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Current Address State:</strong>
            {{ getAllVAHAN02.rc_currentadd_statename }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Current Address District Code:</strong>
            {{ getAllVAHAN02.rc_currentadd_districtcode }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Current Address Pincode:</strong>
            {{ getAllVAHAN02.rc_currentadd_pincode }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Non-use:</strong>
            {{ getAllVAHAN02.rc_non_use }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Passenger Tax:</strong>
            {{ getAllVAHAN02.rc_passenger_tax }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Goods Tax:</strong>
            {{ getAllVAHAN02.rc_goods_tax }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1" v-if="getAllVAHAN02.temp_permit">
            <strong>Temporary Permit Code:</strong>
            {{ getAllVAHAN02.temp_permit.rc_permit_code }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1" v-if="getAllVAHAN02.temp_permit">
            <strong>Temporary Permit Issue Date:</strong>
            {{ getAllVAHAN02.temp_permit.rc_permit_issue_dt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1" v-if="getAllVAHAN02.temp_permit">
            <strong>Temporary Permit Number:</strong>
            {{ getAllVAHAN02.temp_permit.rc_permit_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1" v-if="getAllVAHAN02.temp_permit">
            <strong>Temporary Permit Type:</strong>
            {{ getAllVAHAN02.temp_permit.rc_permit_type }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1" v-if="getAllVAHAN02.temp_permit">
            <strong>Temporary Permit Valid From:</strong>
            {{ getAllVAHAN02.temp_permit.rc_permit_valid_from }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1" v-if="getAllVAHAN02.temp_permit">
            <strong>Temporary Permit Valid Upto:</strong>
            {{ getAllVAHAN02.temp_permit.rc_permit_valid_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Moved On:</strong>
            {{ getAllVAHAN02.rc_permit_moved_on }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>QR URL:</strong>
            {{ getAllVAHAN02.rc_qr_url }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Authorization Name:</strong>
            {{ getAllVAHAN02.rc_auth_name }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Authorization Sign:</strong>
            {{ getAllVAHAN02.rc_auth_sign }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Approval Date:</strong>
            {{ getAllVAHAN02.rc_approval_date }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Horse Power (HP):</strong>
            {{ getAllVAHAN02.rc_hp }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Mandal Description:</strong>
            {{ getAllVAHAN02.rc_mandal_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Taluk Code:</strong>
            {{ getAllVAHAN02.rc_taluk_cd }}
          </b-col>
          <!-- Add any additional fields as needed -->
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllVehicleDDList",
      JSON.stringify({
        itemCode: "getVehicleList",
        vehicleActiveInactiveId: "1",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllVAHAN02Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      vehiclenumber: "",
      getAllVAHAN02: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllVAHAN02Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllVAHAN02 = null;

      if (this.vehiclenumber) {
        payload = {
          itemCode: "VAHAN02",
          funcUrl: "VAHAN/02",
          chasisnumber: this.vehiclenumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("getAllVAHAN02 PS =>", data.xmlJson);
              if (data.xmlJson) {
                this.getAllVAHAN02 = data.xmlJson;
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllVAHAN02 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// VAHAN02_ResponseDisplay.vue?8b1e8eec